import * as Sentry from '@sentry/react';
import { browserTracingIntegration, replayIntegration } from '@sentry/react';

Sentry.init({
  dsn: "https://fa5acf7e489d64d1feda10c35263aef2@o4507674748649472.ingest.us.sentry.io/4511067762786304",
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_APP_VERSION || 'unknown',
  
  integrations: [
    browserTracingIntegration(),
    replayIntegration({
      maskAllText: false,
      blockAllMedia: true,
      mask: [
        'password',
        'secret',
        'token',
        'authorization',
        'creditcard',
        'cvv',
        'ssn',
      ],
    }),
  ],
  
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  replaysSessionSampleRate: import.meta.env.PROD ? 0.05 : 0.1,
  replaysOnErrorSampleRate: 1.0,
  
  beforeSend(event) {
    if (event.request?.headers) {
      delete event.request.headers['Authorization'];
      delete event.request.headers['X-API-Key'];
      delete event.request.headers['Cookie'];
    }
    
    if (event.request?.data) {
      const data = event.request.data as Record<string, unknown>;
      delete data.password;
      delete data.currentPassword;
      delete data.newPassword;
      delete data.confirmPassword;
      delete data.token;
      delete data.apiKey;
      delete data.creditCard;
      delete data.cvv;
      delete data.ssn;
      event.request.data = data;
    }
    
    return event;
  },
  
  ignoreErrors: [
    'ResizeObserver loop',
    'Non-Error promise rejection captured',
    'The user aborted a request',
  ],
});
